export default function getSecondsFromHeight(pixelsPerSection, secondsPerSection, heightPx) {
  const seconds = Math.ceil((heightPx / pixelsPerSection) * secondsPerSection);
  return seconds;
}
